import { defineMessages } from 'react-intl';

export default defineMessages({
  welcomeTo: {
    id: 'Unknown.RealtorHomeScreen.welcomeTo',
    defaultMessage: 'Welcome to the'
  },
  realGeniusRealtor: {
    id: 'Unknown.RealtorHomeScreen.realGeniusRealtor',
    defaultMessage: 'RealGenius.io'
  },
  realGeniusRealtorDescription: {
    id: 'Unknown.RealtorHomeScreen.realGeniusRealtorDescription',
    defaultMessage:
      'RealGenius.io has been created to provide a Partnership Platform between Realtors, Lenders, Title Companies, and vendors.  Working together, even the most complex transactions are made simple and transparent.'
  },
  highlightContent: {
    id: 'Unknown.RealtorHomeScreen.highlightContent',
    defaultMessage:
      'Our unique decisioning tools bring transparency and simplicity to the way Realtors, Clients, and Lenders interact during Real Estate Transactions.'
  },
  learnMoreButton: {
    id: 'Unknown.RealtorHomeScreen.learnMoreButton',
    defaultMessage: 'Want to Learn More,'
  },
  clickHere: {
    id: 'Unknown.RealtorHomeScreen.clickHere',
    defaultMessage: 'Click Here!'
  },
  signUpButton: {
    id: 'Unknown.RealtorHomeScreen.signUpButton',
    defaultMessage: 'Sign Up Today!'
  },
  welcomeButton: {
    id: 'Unknown.RealtorHomeScreen.welcomeButton',
    defaultMessage: 'Welcome'
  },
  loginButton: {
    id: 'Unknown.RealtorHomeScreen.loginButton',
    defaultMessage: 'Login'
  }
});
